import { render } from "./ModulesView.vue?vue&type=template&id=57981c1d"
import script from "./ModulesView.vue?vue&type=script&lang=js"
export * from "./ModulesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__